import React, { useEffect, useState } from "react";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import {
  fetchReferredUsersAsync,
  resetAdminState,
} from "../../../../redux/features/adminSlice";
import WhiteTitledCard from "../../../../components/cards/WhiteTitledCard";
import SearchInput from "../../../../components/form/SearchInput";
import moment from "moment";
import FilterByButton from "../../../ui/FilterButton";

const filterOptions = [
  { label: "All", value: null, onClick: () => {} },
  { label: "Active", value: "active", onClick: () => {} },
  { label: "InActive", value: "inactive", onClick: () => {} },
];

const ReferralTable: React.FC = () => {
  const { ReferredUsers, isLoading } = useAppSelector((state) => state.admin);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState("");
  const [filterByStatus, setFilterByStatus] = useState("");
  const dispatch = useAppDispatch();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Referral Name", field: "Referred_name" },
    { label: "Email", field: "email" },
    { label: "Reg. Date", field: "date_added" },
    { label: "Status", field: "status" },
    { label: "No. of purchases", field: "purchases" },
    // { label: "Action", field: "action" },
  ];

  const mapUserToRow = (user: any, index: number) => ({
    id: page * limit + (index + 1),
    Referred_name: (
      <div className="flex items-center gap-3">
        <img
          src={
            user.profileImage ||
            `https://api.dicebear.com/7.x/initials/svg?seed=${user.referredUser?.firstName}+${user.referredUser?.lastName}`
          }
          alt="avatar"
          className="w-10 h-10 rounded-full object-cover"
        />
        <span className="font-medium text-gray-700">
          {user.referredUser?.firstName} {user.referredUser?.lastName}
        </span>
      </div>
    ),
    email: user.referredUser?.email ?? "N/A",
    date_added: moment(user.createdAt).format("MMM DD, YYYY"),
    purchases: user.numberOfPurchases,
    status: (
      <span
        className={`text-xs px-3 py-1 rounded-md font-semibold ${
          user.status?.toLowerCase() === "active" ? "text-green-500" : ""
        } ${user.status?.toLowerCase() === "inactive" ? "text-red-500" : ""}`}
      >
        {user.status ?? "N/A"}
      </span>
    ),
  });

  const ReferredData = (
    ReferredUsers?.data?.items?.length ? ReferredUsers.data.items : []
  ).map(mapUserToRow);

  useEffect(() => {
    dispatch(resetAdminState());
    dispatch(
      fetchReferredUsersAsync({
        page: page + 1,
        limit,
        referralCode: filter,
        status: filterByStatus,
        search: filter,
      })
    );
  }, [page, limit, filter, filterByStatus, dispatch]);

  return (
    <WhiteTitledCard cardTitle="Referrals History">
      <div className="px-6">
        {/* Search and Filter */}
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-2 w-full md:w-auto">
          <div className="flex gap-2">
            <SearchInput
              placeholder="Search"
              onChange={(e: any) => {
                setFilter(e.target.value);
                setPage(0);
              }}
              value={filter}
            />

            <FilterByButton
              options={filterOptions}
              onSelect={(value) => setFilterByStatus(value)}
            />
          </div>
        </div>

        <CustomTable
          data={{ columns, rows: ReferredData }}
          noRecordText="No Referrals Available"
          loading={isLoading}
          showFooter={true}
          totalPages={ReferredUsers?.data?.meta?.totalPages}
          itemsPerPage={ReferredUsers?.data?.meta?.itemsPerPage}
          currentPage={page}
          onPageChange={(value: number) => setPage(value)}
          onLimitChange={(value: number) => {
            setLimit(value);
            setPage(0);
          }}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default ReferralTable;
